import React, { ReactNode } from 'react';
interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}
export function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-surface px-6 py-20 text-center" data-id="element-64" data-mp="3gw81zw7fdmd1">
      <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-background text-muted-foreground shadow-soft" data-id="element-65" data-mp="3776me74sl6zl">
        {icon}
      </span>
      <h3 className="text-lg font-semibold text-navy" data-id="element-66" data-mp="3bzhjz3c28goz">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground" data-id="element-67" data-mp="2x9s565b1oe68">
        {description}
      </p>
      {action && <div className="mt-7" data-id="element-68" data-mp="328vdbymbn0if">{action}</div>}
    </div>;
}